import { Component, computed, input, output } from '@angular/core';
import { MatDatepickerInputEvent, MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FilterHeaderComponent } from '@vectronic/ui';
import { DateHelper } from '@vectronic/util';
import moment from 'moment';

export interface DateValue {
  beforeDate?: string;
  afterDate?: string;
}

@Component({
  selector: 'table-datatable-filter-date',
  templateUrl: './datatable-filter-date.component.html',
  styleUrls: ['./datatable-filter-date.component.scss'],
  imports: [MatFormFieldModule, MatInputModule, MatDatepickerModule, FilterHeaderComponent],
})
export class DatatableFilterDateComponent {
  title = input.required<string>();
  value = input<DateValue | undefined>();
  expanded = input.required<boolean>();

  valueChange = output<DateValue>();
  toggled = output<void>();

  onAfterDateChange(event: MatDatepickerInputEvent<moment.Moment>) {
    const current = this.value() || {};
    const newValue: DateValue = {
      ...current,
      afterDate: DateHelper.datePickerMomentToIsoDayEnd(event?.value),
    };
    this.valueChange.emit(newValue);
  }

  onBeforeDateChange(event: MatDatepickerInputEvent<moment.Moment>) {
    const current = this.value() || {};
    const newValue: DateValue = {
      ...current,
      beforeDate: DateHelper.datePickerMomentToIsoDayStart(event?.value),
    };
    this.valueChange.emit(newValue);
  }

  beforeDatePickerValue = computed(() => DateHelper.isoToDatePickerDate(this.value()?.beforeDate));

  afterDatePickerValue = computed(() => DateHelper.isoToDatePickerDate(this.value()?.afterDate));
}
